import { useStore } from './use-store';
import { useCurrentDivision } from './use-current-division';
import { CLIENT_SECRETS } from '@/config/client_secrets';

export function useDataContextLabel(dataContext) {
  const [{ insuredName }] = useStore();
  const { currentDivision } = useCurrentDivision();

  if (dataContext === 'Insured' && insuredName) {
    return `Insured: ${insuredName}`;
  }

  if (dataContext === 'Global' && CLIENT_SECRETS.USE_DIVISIONS) {
    if (currentDivision?.name) {
      return `Division: ${currentDivision.name}`;
    }

    return 'Current Division';
  }

  if (dataContext === 'Global') {
    return 'All Insureds';
  }

  return '';
}
